<!-- Translated: skip -->
<template>
  <div class="component">
    <span class="close" @click="close">X</span>
    <div class="container">
      <div class="content">
        <h2>Search</h2>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: [
    'date',
  ],
  methods: {
    close() {
      this.$emit('close', false);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component
  position fixed
  top 0
  width 100vw
  height 100vh
  background-color black-70
  overflow auto

.container
  max-width container-width
  min-height 100%
  margin-right auto
  margin-left auto
  display flex
  align-items center
  text-align center

.content
 background-color white
 border-radius 8px
 padding 20px
.close
  position fixed
  top 3rem
  right 3rem
  color white
  font-size 3rem
  cursor pointer
</style>



// WEBPACK FOOTER //
// SearchModal.vue?47830ee6